
















































































import {
  defineComponent,
  computed,
  ref,
  useContext
} from '@nuxtjs/composition-api';

type specificationType = {
  property_question?: string;
  property_group?: string;
  property_answer?: string;
  con_tip: boolean;
  pro_tip: boolean;
  _id: number;
};

export default defineComponent({
  name: 'Specifications',
  props: {
    specifications: {
      type: Array,
      required: true,
      default: []
    },
    loaded: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { i18n } = useContext();

    const groups = computed(() => {
      return ((props.specifications || []) as Array<specificationType>).reduce(
        (acc, spec: specificationType) => {
          // skip product short items
          if (
            spec.property_question &&
            spec.property_question.toLowerCase().includes('product short')
          )
            return acc;

          if (!acc[spec.property_group]) {
            acc[spec.property_group] = [];
          }
          let answer: string;
          switch (spec.property_answer.toLowerCase()) {
            case 'ja':
              answer = 'green-check';
              break;
            case 'nee':
              answer = 'red-cross';
              break;
            default:
              answer = spec.property_answer;
              break;
          }
          acc[spec.property_group].push({
            id: spec._id,
            label: spec.property_question,
            entry: answer
          });
          return acc;
        },
        {}
      );
    });

    const mobileList = ref([]);
    const leftSide = ref([]);
    const rightSide = ref([]);

    const fillSides = () => {
      let totalLengthLeft = 0;
      let totalLengthRight = 0;
      if (!groups.value) return;

      // add article number (KAME-2768)
      const groupsWithArticleNumber = { ...groups.value } as {
        [key: string]: any;
      };
      const generalGroupKey = i18n.t('specifications_general_group') as string;
      const articleNumberItem = {
        label: i18n.t('article_number'),
        entry: props.product.sku
      };
      if (!groupsWithArticleNumber[generalGroupKey]) {
        groupsWithArticleNumber.Info = [articleNumberItem];
      } else {
        groupsWithArticleNumber[generalGroupKey].unshift(articleNumberItem);
      }

      for (const group of Object.keys(groupsWithArticleNumber).sort()) {
        const length = groupsWithArticleNumber[group].length;
        const item = {
          title: group,
          content: groupsWithArticleNumber[group],
          desktopOnly: false
        };
        mobileList.value.push(item);
        if (totalLengthLeft <= totalLengthRight) {
          totalLengthLeft += length;
          leftSide.value.push(item);
        } else {
          totalLengthRight += length;
          rightSide.value.push(item);
        }
      }
    };

    if (groups) {
      fillSides();
    }

    return {
      mobileList,
      leftSide,
      rightSide,
      hasLoadedSpecifications: props.loaded
    };
  }
});
